import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { landingMediaSlice } from '../slices/landginMediaSlice';
import { paymentChoiceSlice } from '../slices/paymentChoiceSlice';
import { inputSaleSliceReducer } from '../slices/inputSaleSice';

const rootReducer = combineReducers({
  media: landingMediaSlice.reducer,
  paymentChoice: paymentChoiceSlice.reducer,
  inputSale: inputSaleSliceReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});
